import React, { Component } from 'react'
import { AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    bottom: 0,
    textAlign: 'center',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
  },
}))

export const Footer = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Typography></Typography>
    </div>
  )
}
